/* ==========================================================================
   Solid Viibe — announcement bar, sticky header state, mobile drawer
   Ported from the approved prototype's sv-common.js.
   ========================================================================== */
(function () {
  'use strict';

  var STORAGE_KEY = 'sv-announcement-dismissed';

  function initAnnouncement(scope) {
    var bar = scope.querySelector('[data-announcement]');
    if (!bar) return;

    try {
      if (window.sessionStorage.getItem(STORAGE_KEY) === '1' && !window.Shopify?.designMode) {
        bar.remove();
        return;
      }
    } catch (err) { /* private mode — show the bar */ }

    var messages = Array.prototype.slice.call(bar.querySelectorAll('.sv-announcement__msg'));
    if (messages.length > 1) {
      var i = 0;
      var every = parseInt(bar.dataset.announcementInterval, 10) || 4500;
      window.setInterval(function () {
        messages[i].hidden = true;
        i = (i + 1) % messages.length;
        messages[i].hidden = false;
      }, every);
    }

    var close = bar.querySelector('[data-announcement-close]');
    if (close) {
      close.addEventListener('click', function () {
        bar.remove();
        try { window.sessionStorage.setItem(STORAGE_KEY, '1'); } catch (err) { /* no-op */ }
      });
    }
  }

  function initHeader(scope) {
    var header = scope.querySelector('[data-header]');
    if (!header) return;
    var setStuck = function () {
      header.dataset.stuck = window.scrollY > 8 ? 'true' : 'false';
    };
    setStuck();
    window.addEventListener('scroll', setStuck, { passive: true });

    /* Publish the header height as --sv-header-h.

       Several stylesheets offset sticky rails and scroll targets by this,
       and every one of them was guessing at 5rem against a header that is
       actually 63px - so contents links landed under the header and the
       article progress bar floated in a gap below it. The height changes
       with the breakpoint and with the announcement bar, so it is measured
       rather than written down. */
    var publishHeight = function () {
      document.documentElement.style.setProperty(
        '--sv-header-h', header.getBoundingClientRect().height + 'px'
      );
    };
    publishHeight();
    if (window.ResizeObserver) {
      new ResizeObserver(publishHeight).observe(header);
    } else {
      window.addEventListener('resize', publishHeight, { passive: true });
    }
  }

  function initDrawer(scope) {
    var drawer = scope.querySelector('[data-drawer]');
    var overlay = scope.querySelector('[data-overlay]');
    var openers = scope.querySelectorAll('[data-drawer-open]');
    var closers = scope.querySelectorAll('[data-drawer-close]');
    if (!drawer) return;

    var lastFocused = null;

    function setDrawer(open) {
      drawer.dataset.open = String(open);
      drawer.setAttribute('aria-hidden', String(!open));
      if (open) { drawer.removeAttribute('inert'); } else { drawer.setAttribute('inert', ''); }
      if (overlay) overlay.dataset.open = String(open);
      document.body.style.overflow = open ? 'hidden' : '';
      openers.forEach(function (b) { b.setAttribute('aria-expanded', String(open)); });
      if (open) {
        lastFocused = document.activeElement;
        var first = drawer.querySelector('a, button');
        if (first) first.focus();
      } else if (lastFocused && typeof lastFocused.focus === 'function') {
        lastFocused.focus();
        lastFocused = null;
      }
    }

    openers.forEach(function (b) { b.addEventListener('click', function () { setDrawer(true); }); });
    closers.forEach(function (b) { b.addEventListener('click', function () { setDrawer(false); }); });
    if (overlay) overlay.addEventListener('click', function () { setDrawer(false); });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.dataset.open === 'true') setDrawer(false);
    });

    /* Focus trap while the drawer is open. */
    drawer.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab' || drawer.dataset.open !== 'true') return;
      var focusables = drawer.querySelectorAll('a[href], button:not([disabled]), input, select, textarea');
      if (!focusables.length) return;
      var first = focusables[0];
      var last = focusables[focusables.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    });
  }

  function init(scope) {
    initAnnouncement(scope);
    initHeader(scope);
    initDrawer(scope);
  }

  init(document);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
